import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-usecase-database',
  templateUrl: './usecase-database.component.html',
  styleUrls: ['./usecase-database.component.scss']
})
export class UsecaseDatabaseComponent extends BaseListCtl {

  public applicationId: number = 0;
  public UserList: any[] = [];
  public searchText: string = '';
  public searchLogicCode: string = '';
  public searchMobile: string = '';
  public sortedField: string | null = null;
  public sortOrder: 'ASC' | 'DESC' | null = null;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);

    this.applicationId = Number(this.route.snapshot.paramMap.get('appId'));
    this.getUsers();
  }

  getUsers() {
    const url = this.locator.config.get('endpoint.user') + '/getUser/' + this.applicationId;

    this.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error: ' + error);
        this.UserList = [];
        this.rebuildPageList();
        return;
      }
      this.UserList = res.result?.data || [];
      this.rebuildPageList();
    });
  }

  searchUsers() {
    const url = this.locator.config.get('endpoint.user') + '/getUserSearch/' + this.applicationId;

    const payload: any = { appId: this.applicationId };

    if (this.searchText?.trim())         payload.login     = this.searchText.trim();
    if (this.searchLogicCode?.trim())    payload.loginCode = this.searchLogicCode.trim();
    if (this.searchMobile?.toString().trim()) payload.mobileId = this.searchMobile.toString().trim();

    this.locator.http.post(url, payload, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error: ' + error);
        this.UserList = [];
        this.rebuildPageList();
        return;
      }
      this.UserList = res.result?.data || [];
      this.rebuildPageList();
    });
  }

  resetFilters() {
    this.searchText = '';
    this.searchLogicCode = '';
    this.searchMobile = '';
    this.getUsers();
  }

  sortTable(field: string): void {
    if (this.sortedField === field) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortedField = field;
      this.sortOrder = 'ASC';
    }
    this.UserList = [...this.UserList].sort((a, b) => {
      const valA = (a[field] || '').toString().toLowerCase();
      const valB = (b[field] || '').toString().toLowerCase();
      if (valA < valB) return this.sortOrder === 'ASC' ? -1 : 1;
      if (valA > valB) return this.sortOrder === 'ASC' ? 1 : -1;
      return 0;
    });
  }

  private rebuildPageList(): void {
    const pageSize = this.form.pageSize || 50;
    const pageCount = Math.ceil(this.UserList.length / pageSize) || 1;
    this.form.pageNo = 0;
    this.form.pageCount = pageCount;
    this.form.pageNoList = [];
    for (let i = 0; i < pageCount; i++) {
      this.form.pageNoList.push(i);
    }
  }
}